import styled from "styled-components";

const Section = styled.header`
  text-align: ${props => (props.centered ? "center" : "auto")};
`;

export default Section;
